/* 🤖 this file was generated by script */
export const wiconFiles = {
  name: 'files',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.98 2.36l4.1 4.09m-4.1-4.1H6.41v13.06h9.66V6.45m-4.09-4.1v4.1h4.1M4.43 4.59h-.51v13.05h9.03"/></svg>`,
};
